module.exports = __webpack_public_path__ + "img/select.92e9626b.png";